var map = {
	"./images/contact/dubai.jpg": 5869,
	"./images/contact/london-hq.jpg": 7728,
	"./images/contact/singapore.jpg": 9936,
	"./images/home/wallpaper-image-04.jpg": 4264,
	"./images/how-to-join/internship-image-01.jpeg": 7766,
	"./images/how-to-join/interview-image-01.jpeg": 9045,
	"./images/how-to-join/mqcapital-image-11.jpg": 2762,
	"./images/how-to-join/mqcapital-image-25.jpg": 8227,
	"./images/how-to-join/wallpaper-image-03.jpg": 9659,
	"./images/legal/mqcapital-image-21.jpg": 6389,
	"./images/library/monthly-reports.jpg": 9842,
	"./images/library/weekly-marketinsight.jpeg": 4178,
	"./images/seo/home-og-image.jpg": 8225,
	"./images/seo/how-to-join-og-image.jpg": 8385,
	"./images/seo/library-og-image.jpg": 1489,
	"./images/seo/og-image.jpg": 5895,
	"./images/seo/what-we-do-og-image.jpg": 175,
	"./images/strategies/amc-schema.svg": 4460,
	"./images/strategies/mqcapital-image-02.jpg": 8008,
	"./images/strategies/wallpaper-image-02.jpg": 8096,
	"./images/who-we-are/csr-image-02.jpeg": 6060
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5488;